import React from "react";
import {BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import {EMandatePrompt} from './components/EMandatePrompt'
import {Redirect} from "./components/Redirect";
import {Timeout} from "./components/Timeout";
import {Failed} from "./components/Failed";
import {Done} from "./components/Done";
import './App.css'

export default function App() {
    return (
        <Router>
            <div>
                <Routes>
                    <Route path='/emandate/:loanId' element={<EMandatePrompt/>}/>
                    <Route path='/redirect/:transaction_id' element={<Redirect/>}/>
                    <Route path='/timeout' element={<Timeout/>}/>
                    <Route path='/failed' element={<Failed/>}/>
                    <Route path='/done' element={<Done/>}/>
                </Routes>
            </div>
        </Router>
    );
}
